<template>
  <div class="progress-info">
    <div
      class="empty"
      v-if="from === 'sheetBacked' && (!progress.stepCid || stepControl === undefined)"
    >
      步骤条为空，添加字段后才能显示
    </div>
    <div v-if="progressList && progressList.length" class="step-info">
      <div class="name">{{ stepControl.name + "：" }}</div>
      <div class="step-list" v-ps>
        <div class="list-info">
          <div v-for="(step, index) in progressList" ref="progress" :key="index">
            <text-des-popper :value="step.description">
              <template v-slot:reference>
                <div class="step-item" :class="step.description ? 'pointer' : ''">
                  <svg-icon
                    class="icon"
                    :icon-class="
                      index === 0
                        ? 'detail_step-begin'
                        : index + 1 === progressList.length
                        ? 'detail_step-end'
                        : 'detail_step-mid'
                    "
                    :color="stepIconColorMap[step.state]"
                  ></svg-icon>
                  <div
                    class="value"
                    :style="
                      (index === 0
                        ? 'left:0; width:140px;'
                        : index + 1 === progressList.length
                        ? 'left:15px; width:138px;'
                        : 'left:15px; width:125px;') +
                        'color:' +
                        stepValueColorMap[step.state]
                    "
                  >
                    <div class="value-info" v-tip>
                      <svg-icon
                        v-if="step.state === 'current'"
                        icon-class="detail_current-state"
                        style="margin-right: 4px"
                      ></svg-icon>
                      <span>{{ step.label }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </text-des-popper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextDesPopper from "@/components/BaseComponents/TextDesPopper"
import {
  stepIconColorMap,
  stepValueColorMap
} from "@/views/Backend/AdminEdit/Sheet/Field/fields-content/static"

export default {
  name: "progress-info",
  components: { TextDesPopper },
  props: {
    progress: Object,
    controlMap: Object,
    from: String,
    // 详情展示中需要使用
    sheetData: {
      type: Object,
      default: () => ({ data: {} })
    }
  },
  data() {
    return {
      stepIconColorMap,
      stepValueColorMap,
      stepList: []
    }
  },
  computed: {
    stepControl() {
      return this.controlMap[this.progress.stepCid]
    },
    stepValueList() {
      return this.progress.stepList?.map(step => step.value)
    },
    progressList() {
      let result = []
      let curIndex = 0
      if (this.from === "sheetFront") {
        let curState = ""
        if (
          this.sheetData?.data &&
          this.sheetData?.data[this.progress.stepCid] &&
          this.sheetData?.data[this.progress.stepCid].length
        )
          curState = this.sheetData?.data[this.progress.stepCid][0]
        curIndex = this.stepList?.findIndex(step => step.value === curState)
      }
      this.stepList?.forEach((step, index) => {
        let pStep = {}
        if (this.stepValueList.includes(step.value)) {
          pStep = this.progress.stepList?.find(progressStep => progressStep.value === step.value)
        } else {
          pStep = step
        }
        if (this.from === "sheetBacked") pStep.state = "before"
        else {
          if (curIndex === -1) {
            pStep.state = "before"
          } else if (curIndex < index) {
            pStep.state = "after"
          } else if (curIndex === index) {
            pStep.state = "current"
          } else {
            pStep.state = "before"
          }
        }
        result.push(pStep)
      })
      return result
    }
  },
  watch: {
    "progress.stepCid": {
      handler() {
        if (this.progress.stepCid) {
          this.stepList = this.stepControl?.options
        }
      },
      immediate: true
    },
    progressList: {
      handler() {
        let index = this.progressList?.findIndex(progress => progress.state === "current")
        if (index !== -1) this.$nextTick(() => this.$refs.progress[index]?.scrollIntoView())
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-info {
  box-sizing: border-box;
  &:hover {
    .empty {
      border-style: dashed;
      border-color: #777;
    }
  }
  .empty {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    font-size: $font-size-main;
    color: #777;
    background-color: #f5f7fa;
    cursor: pointer;
    margin: 12px 0;
  }
  .step-info {
    display: flex;
    align-items: center;
    margin-top: 10px;
    .name {
      font-size: 14px;
      color: #313132;
      font-weight: 500;
      padding-bottom: 12px;
    }
    .step-list {
      flex: 1;
      height: 32px;
      padding-bottom: 12px;
      .list-info {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        height: 100%;
        .step-item {
          display: flex;
          align-items: center;
          height: 32px;
          position: relative;
          .icon {
            font-size: 155px;
            height: 32px;
          }
          .value {
            position: absolute;
            font-size: 14px;
            width: 140px;
            top: 6px;
            .value-info {
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
